@if (!requested) {
  <i class="Appkit4-icon icon-circle-empty-outline text-xl p-1" title="{{tooltip}}" style="color: #AFAFAF" ></i>
} @else {
  @if (queryStatus === 'Completed') {
    <i class="Appkit4-icon icon-circle-checkmark-outline text-xl p-1" title="{{tooltip}}" style="color: #4ead58"></i>
  } @else {
    @if (queryStatus === 'Pending' || queryStatus === 'Running') {
      <i class="Appkit4-icon icon-circle-more-outline text-xl p-1" title="{{tooltip}}" style="color: #FFBF1F"></i>
    } @else {
      <i class="Appkit4-icon icon-circle-delete-outline text-xl p-1" title="{{tooltip}}" style="color: #c52a1a"></i>
    }
  }
}
